import React from 'react';

/*
 * The line icons Review and book draws (SF 74): no emoji, each in the colour
 * of the words beside it (Lena, 11 Oct). Drawn here so no icon package is
 * added (CLAUDE.md).
 */

interface IconProps {
  size?: number;
  color?: string;
  /** 2 by default; a small icon the board draws bolder (Time & groomer's clock, 2.4) can say so. */
  strokeWidth?: number;
}

const Svg: React.FC<IconProps & { children: React.ReactNode }> = ({ size = 18, color = 'currentColor', strokeWidth = 2, children }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
    style={{ display: 'inline-block', flexShrink: 0 }}
  >
    {children}
  </svg>
);

export const CalendarIcon: React.FC<IconProps> = props => (
  <Svg {...props}>
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <path d="M16 2v4M8 2v4M3 10h18" />
  </Svg>
);

export const ScissorsIcon: React.FC<IconProps> = props => (
  <Svg {...props}>
    <circle cx="6" cy="6" r="3" />
    <circle cx="6" cy="18" r="3" />
    <path d="M20 4 8.12 15.88M14.47 14.48 20 20M8.12 8.12 12 12" />
  </Svg>
);

export const PinIcon: React.FC<IconProps> = props => (
  <Svg {...props}>
    <path d="M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 0 1 16 0Z" />
    <circle cx="12" cy="10" r="3" />
  </Svg>
);

export const PackageIcon: React.FC<IconProps> = props => (
  <Svg {...props}>
    <path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z" />
    <path d="M12 22V12M3.3 7l8.7 5 8.7-5M7.5 4.27l9 5.15" />
  </Svg>
);

export const TagIcon: React.FC<IconProps> = props => (
  <Svg {...props}>
    <path d="M12.59 2.59A2 2 0 0 0 11.17 2H4a2 2 0 0 0-2 2v7.17a2 2 0 0 0 .59 1.42l8.7 8.7a2.43 2.43 0 0 0 3.42 0l6.58-6.58a2.43 2.43 0 0 0 0-3.42z" />
    <circle cx="7.5" cy="7.5" r="1.2" />
  </Svg>
);

export const CameraIcon: React.FC<IconProps> = props => (
  <Svg {...props}>
    <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z" />
    <circle cx="12" cy="13" r="3" />
  </Svg>
);

export const LockIcon: React.FC<IconProps> = props => (
  <Svg {...props}>
    <rect x="3" y="11" width="18" height="11" rx="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </Svg>
);

// The booked page's (SF 75/76).

export const CheckIcon: React.FC<IconProps> = props => (
  <Svg {...props}>
    <path d="M20 6 9 17l-5-5" />
  </Svg>
);

export const NavigateIcon: React.FC<IconProps> = props => (
  <Svg {...props}>
    <path d="m3 11 19-9-9 19-2-8-8-2z" />
  </Svg>
);

export const NoteIcon: React.FC<IconProps> = props => (
  <Svg {...props}>
    <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
    <path d="M14 2v4a2 2 0 0 0 2 2h4M16 13H8M16 17H8M10 9H8" />
  </Svg>
);

export const PersonIcon: React.FC<IconProps> = props => (
  <Svg {...props}>
    <circle cx="12" cy="8" r="4" />
    <path d="M4 21v-1a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v1" />
  </Svg>
);

export const RepeatIcon: React.FC<IconProps> = props => (
  <Svg {...props}>
    <path d="M3 12a9 9 0 0 1 15.5-6.2L21 8" />
    <path d="M21 3v5h-5" />
    <path d="M21 12a9 9 0 0 1-15.5 6.2L3 16" />
    <path d="M3 21v-5h5" />
  </Svg>
);

export const CircleXIcon: React.FC<IconProps> = props => (
  <Svg {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M15 9l-6 6M9 9l6 6" />
  </Svg>
);

export const CardIcon: React.FC<IconProps> = props => (
  <Svg {...props}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M3 10h18M7 15h3" />
  </Svg>
);

export const PhoneIcon: React.FC<IconProps> = props => (
  <Svg {...props}>
    <path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2Z" />
  </Svg>
);

// My booking's (SF 08–10), and Time & groomer's Next available (SF 73, 78).

export const ClockIcon: React.FC<IconProps> = props => (
  <Svg {...props}>
    <circle cx="12" cy="12" r="10" />
    <path d="M12 6v6l4 2" />
  </Svg>
);

// Messages (SF 74's row, MKT 16).

/** A speech bubble: the Messages row and the profile's entry. */
export const MessageIcon: React.FC<IconProps> = props => (
  <Svg {...props}>
    <path d="M21 12a8 8 0 0 1-11.6 7.1L4 20.5l1.4-4.6A8 8 0 1 1 21 12Z" />
  </Svg>
);

/** An envelope: offers by email. */
export const MailIcon: React.FC<IconProps> = props => (
  <Svg {...props}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="m3 7 9 6 9-6" />
  </Svg>
);

// My bookings (Appointments) in place of its emoji (15 Oct 2026).

/** A signal with a line through it: the page couldn't reach the salon. */
export const OfflineIcon: React.FC<IconProps> = props => (
  <Svg {...props}>
    <path d="M2 2l20 20" />
    <path d="M8.5 16.5a5 5 0 0 1 7 0" />
    <path d="M5 12.86a10 10 0 0 1 5.17-2.69" />
    <path d="M19 12.86a10 10 0 0 0-2.01-1.52" />
    <path d="M2 8.82a15 15 0 0 1 4.17-2.65" />
    <path d="M10.66 5c4.01-.36 8.14.9 11.34 3.76" />
    <path d="M12 20h.01" />
  </Svg>
);
